
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CancelButton from "./buttons/CancelButton.vue";
import EditButton from "./buttons/EditButton.vue";
import DangerButton from "./buttons/DangerButton.vue";
import InfoDialog from "./dialogs/InfoDialog.vue";

@Component({
  components: {
    CancelButton,
    EditButton,
    DangerButton,
    InfoDialog,
  },
})
export default class EditFrame extends Vue {
  @Prop({
    default: false,
  })
  hideControls!: boolean;

  @Prop()
  noPadding: boolean | undefined;

  @Prop()
  width!: number;

  @Prop()
  height!: number;

  @Prop()
  title: string | undefined;

  @Prop()
  info: string | undefined;

  @Prop({ required: false, default: false })
  disabled!: boolean;

  @Prop()
  icon?: string;

  @Prop({ default: false }) isEditing!: boolean;

  showInfoDialog = false;
  hasValidationErrors = false;

  public onEdit(): void {
    this.$emit("update:isEditing", true);
    (this.$refs.form as any).validate();
    this.$emit("edit");
  }

  public onSave(): void {
    this.$emit("update:isEditing", false);
    this.$emit("save");
  }

  public onCancel(): void {
    this.$emit("update:isEditing", false);
    this.$emit("cancel");
  }

  @Watch("hasValidationErrors")
  onValidChanged(value: boolean): void {
    this.$emit("valid", value);
  }
}
